import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableRow, TableCell, TextField, MenuItem } from '@material-ui/core';

import { TenderComponentProps } from '../OCDTypes';

import useTender from './useTender';

function TenderDesktop({
  onChange,
  isMissingReason,
  name,
  type,
  expected,
  counted,
  reason,
  isFirst,
  billsTotal,
}: TenderComponentProps) {
  const { t } = useTranslation('openCloseDay', {
    keyPrefix: 'closeDay.tenders',
  });

  const {
    showExpected,
    countedProps,
    expectedProps,
    differenceProps,
    reasonProps,
  } = useTender({
    billsTotal,
    onChange,
    isMissingReason,
    type,
    expected,
    counted,
    reason,
    isFirst,
  });

  return (
    <TableRow>
      <TableCell data-testid="input-header" data-test-key={type}>
        {t(`tenders.${type}`, name)}
      </TableCell>
      <TableCell>
        <TextField
          size="small"
          fullWidth
          variant="outlined"
          data-testid="input"
          data-test-key={type}
          name={type}
          className={countedProps.className}
          value={countedProps.value}
          placeholder={countedProps.placeholder}
          onChange={countedProps.onChange}
          error={countedProps.error}
        />
      </TableCell>
      {showExpected && (
        <>
          <TableCell
            data-testid="expected"
            style={{ textAlign: 'right' }}
            data-test-key={type}
          >
            {expectedProps.value}
          </TableCell>
          <TableCell
            data-testid="diff"
            data-test-key={type}
            style={{ textAlign: 'right' }}
          >
            {differenceProps.value}
          </TableCell>
          <TableCell>
            <TextField
              size="small"
              fullWidth
              variant="outlined"
              data-testid="reason-select"
              data-test-key={type}
              select
              value={reasonProps.value}
              onChange={reasonProps.onChange}
              error={reasonProps.error}
            >
              {reasonProps.options.map(({ name, reasonID }) => (
                <MenuItem key={reasonID} value={reasonID}>
                  {name}
                </MenuItem>
              ))}
            </TextField>
          </TableCell>
        </>
      )}
    </TableRow>
  );
}

export default TenderDesktop;
